import React from "react";

const PrivacyPolicy = () => (
  <div style={{ maxWidth: 800, margin: "2rem auto", padding: "2rem" }}>
    <h1>Privacy Policy</h1>
    <p>Last updated: October 15, 2025</p>
    <p>
      IonianFarsi (“we”, “us”, or “our”) operates the website <a href="https://ionianfarsi.gr">ionianfarsi.gr</a> and provides language learning services. This Privacy Policy explains how we collect, use, and protect your information when you use our website and services.<br /><br />
      <strong>Note:</strong> This Privacy Policy was written by GitHub Copilot AI agent at the request of the developer. The developer asked Copilot to clearly state this for transparency and compliance.
    </p>
    <h2>Information We Collect</h2>
    <ul>
      <li>
        <strong>Google Account Information:</strong> When you sign up or log in using Google, we receive your name, email address, Google ID, and profile picture from Google. We do not access your Google password.<br />
        <em>Google user data is only used to create and manage your account, personalize your experience, and provide secure authentication. We do not use, store, or share Google user data for any other purpose except as described in this policy and required to provide our service.</em>
      </li>
      <li>
        <strong>Account Data:</strong> We store your username, learning progress, and other profile information necessary for your account.
      </li>
      <li>
        <strong>Usage Data:</strong> We may collect information about how you use our website to improve our services.
      </li>
    </ul>
    <h2>How We Use Your Information</h2>
    <ul>
      <li>To create and manage your account</li>
      <li>To provide and improve our language learning services</li>
      <li>To communicate with you about your account or updates</li>
      <li>To ensure security and prevent fraud</li>
      <li>To comply with Google’s Limited Use requirements for user data</li>
    </ul>
    <h2>How We Protect Your Information</h2>
    <p>
      We use industry-standard security measures to protect your data. Access tokens and sensitive information are stored securely. We do not share your personal information with third parties except as required by law or to provide our services (e.g., Google authentication).<br />
      <em>We do not use Google user data for advertising, analytics, or any purpose not disclosed in this policy. Your Google data is never sold or shared with third parties except as required to provide our service or by law.</em>
    </p>
    <h2>Your Rights</h2>
    <ul>
      <li>You can request access to or deletion of your personal data by contacting us at <a href="mailto:inf2022001@ionio.gr">inf2022001@ionio.gr</a>.</li>
      <li>You can disconnect your Google account at any time.</li>
      <li>You can request information about how your Google user data is used, stored, or shared.</li>
    </ul>
    <h2>Cookies</h2>
    <p>
      We use cookies for authentication and to improve user experience. You can control cookies through your browser settings.
    </p>
    <h2>Changes to This Policy</h2>
    <p>
      We may update this Privacy Policy from time to time. Changes will be posted on this page.
    </p>
    <h2>Contact Us</h2>
    <p>
      If you have any questions about this Privacy Policy, please contact us at <a href="mailto:inf2022001@ionio.gr">inf2022001@ionio.gr</a>.
    </p>
  </div>
);

export default PrivacyPolicy;
